module.exports = __webpack_public_path__ + "static/media/milestone-card-bg.33c5b51d.png";